import { Eye, Flag } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { aboutPageData } from "../../data/aboutData";

function AboutVisionMission() {
  const { visionMission, values } = aboutPageData;
  const icons = [Eye, Flag];

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
          <div className="signature-card rounded-[1.8rem] p-6 md:p-8">
            <SectionHeading
              center={false}
              kicker="Vision & Mission"
              title="The Principles That Guide NextEra"
              description="We combine purpose-led strategy with real human support so every student can make informed decisions."
            />

            <div className="mt-8 grid gap-4 md:grid-cols-2">
              {visionMission.map((item, index) => {
                const Icon = icons[index % icons.length];

                return (
                  <article
                    key={item.title}
                    className="signature-card signature-card-interactive rounded-2xl p-5"
                  >
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white text-royal-blue">
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <h3 className="mt-4 text-2xl leading-tight">{item.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-text/85">{item.text}</p>
                  </article>
                );
              })}
            </div>
          </div>

          <div className="rounded-[1.8rem] border border-midnight-navy/10 bg-cta-glow p-6 shadow-luxury md:p-8">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-sky-glow/85">Core Values</p>
            <h3 className="mt-3 text-2xl leading-tight text-soft-white sm:text-3xl">How We Show Up for Students</h3>

            <div className="mt-6 space-y-3">
              {values.map((value) => (
                <div
                  key={value}
                  className="rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-sm font-medium text-soft-white"
                >
                  {value}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutVisionMission;
